import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { EventMenuProfileService } from 'src/app/components/profile-menu/profile-menu.service';
import { ApiCore } from 'src/app/config/api';
import { AppConstants } from 'src/app/config/constants';
import { ApiService } from 'src/app/core/http/api.service';
import { ToolsValidations } from 'src/app/core/tools/tools.validators';
import { UserProfileInterface } from './interfaces/user-profile.interface';

@Component({
  selector: 'app-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.css'],
})
export class PersonalDataComponent implements OnInit {
  maxDate = new Date();
  public loading = true;
  public calendarOpen = false;
  public loadingPicture: boolean = true;
  public isMobile = false;
  public formIsDifferent: boolean = false;
  public profilePicture: string = AppConstants.IMAGE_AVATAR_DEFAULT;
  public profileInMobile: string = AppConstants.IMAGE_AVATAR_DEFAULT;
  //TODO: Make this Types
  public oldForm: any;
  public generes_catalog: any[] = [];
  public userProfile!: UserProfileInterface;
  countries_code_catalog: any[] = [];
  public selectedCountry: any = //{ id:'clabcdo4k000yur7c0eem0noj', country: 'México', ladaCode: '(+52)', flagCode: 'mx' };
    {
      id: 'clabcdo4k000yur7c0eem0noj',
      country: 'México',
      ladaCode: '(+52)',
      flagCode: 'mx',
      isActive: true,
      createdAt: '2022-11-10T17:26:30.493Z',
      updatedAt: '2022-11-10T17:23:12.321Z',
    };
  public hasCompleteInformation = false;
  public profilePictureEdit: any = '../assets/images/pencil.png';
  public profileForm: FormGroup = this.formBuilder.group({
    userName: ['', []],
    mail: ['', []],
    firstName: ['', [this.customValidator('Nombre')]],
    lastName: ['', [this.customValidator('Apellido')]],
    birthday: ['', [this.minAgeValidator(18)]],
    genere: ['', []],
    phoneNumber: ['', [this.validatorPhone()]],
  });
  public showLoadSkeleton = false;
  public userVrified: string = 'N'; //N-New P-In Progress C-Completed
  public messageUserFullNameError: string = '';
  public messageUserFullLastNameError: string = '';
  public messagePhoneNumberError: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly messageService: MessageService,
    private readonly apiService: ApiService,
    private readonly eventMenuProfileService: EventMenuProfileService
  ) {
    this.eventMenuProfileService.$eventNewPicture.subscribe((url: string) => {
      console.log('CAMBIANDO ELN PICTURE', url);
      this.profilePicture = url;
    });
    this.eventMenuProfileService.$eventNewProfile.subscribe(() => {
      this.loadUserData();
    });
  }

  ngOnInit(): void {
    this.loadUserData();

    this.apiService
      .list(ApiCore.CATALOGS + 'country-codes-catalog')
      .subscribe((res) => {
        //console.log(res)
        this.countries_code_catalog = res.data;
      });

    this.apiService
      .list(ApiCore.CATALOGS + 'gender-catalog')
      .subscribe((res) => {
        this.generes_catalog = res.data;
        this.generes_catalog.splice(0, 0, {
          id: null,
          name: 'Selecciona tu género',
          description: 'Selecciona tu género',
        });
      });

    var inputElement = document.getElementById('upload-file');
    if (inputElement != null) {
      inputElement.onclick = function (event) {};
      inputElement.onblur = function (event) {};
      inputElement.onabort = function (event) {};
      inputElement.onchange = function (event) {};
      inputElement.onclose = function (event) {};
    }
    // this.checkValueChanges();
  }
  checkValueChanges() {
    const initialValue = this.profileForm.value;
    this.profileForm.valueChanges.subscribe((value) => {
      // console.log({value});
      // console.log('OLD FORM', this.oldForm);
      // console.log('NEW FORM', this.profileForm.value);

      if (this.oldForm?.mail || this.oldForm?.userName) {
        // console.log({value});
        // console.log(this.oldForm);
        const data = Object.keys(initialValue).some(
          (key) => this.profileForm.value[key] != this.oldForm[key]
        );
        // console.log({data});
        this.formIsDifferent = data;
      }
    });
  }
  loadUserData() {
    this.showLoadSkeleton = true;
    this.loadingPicture = true;
    this.apiService.list(ApiCore.USER + '/me').subscribe({
      next: (res) => {
        this.userProfile = res.data;
        this.setValues();
        this.showLoadSkeleton = false;
        this.loadingPicture = false;
      },
      error: (err) => {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'Error al cargar la información del usuario',
        });
      },
    });
  }
  setValues() {
    this.profileForm.get('userName')?.setValue(this.userProfile.userName);
    this.profileForm.get('mail')?.setValue(this.userProfile.email);
    this.profileForm.get('firstName')?.setValue(this.userProfile.firstName);
    this.profileForm.get('lastName')?.setValue(this.userProfile.lastName);
    // this.profileForm
    //   .get('birthday')
    //   ?.setValue(
    //     this.userProfile.birthday
    //       ? moment.parseZone(this.userProfile.birthday).format('YYYY-MM-DD')
    //       : null
    //   );
    this.profileForm
      .get('birthday')
      ?.setValue(
        this.userProfile.birthday
          ? moment.parseZone(this.userProfile.birthday).toDate()
          : null
      );

    this.profileForm
      .get('genere')
      ?.setValue(
        this.userProfile.genderCatId ? this.userProfile.genderCatId : 'null'
      );
    this.profileForm.get('phoneNumber')?.setValue(this.userProfile.phoneNumber);
    this.profileForm
      .get('country')
      ?.setValue(this.userProfile.countryCode ?? this.selectedCountry);
    this.profilePicture =
      this.userProfile.profilePictureUrl ?? AppConstants.IMAGE_AVATAR_DEFAULT;
    this.profileInMobile =
      this.userProfile.profilePictureUrl ?? AppConstants.IMAGE_AVATAR_DEFAULT;
    this.hasCompleteInformation = this.profileForm.valid;
    this.oldForm = this.profileForm.value;
    this.loading = false;
    this.profileForm.markAsPristine();
  }
  changeSelect() {
    this.selectedCountry = this.profileForm.get('country')?.value;
    console.log(this.selectedCountry);
  }
  validateUserFullName() {
    const user_full_name: string = this.profileForm
      .get('firstName')
      ?.value.trim();
    if (
      (user_full_name.length < 3 || user_full_name.length > 30) &&
      user_full_name.length != 0
    )
      this.messageUserFullNameError = 'Nombre debe tener de 3 a 30 caracteres';
    else if (
      !RegExp(ToolsValidations.patternUserFullNameComplete).test(user_full_name)
    )
      this.messageUserFullNameError =
        'Nombre no puede tener caracteres especiales';
    else this.messageUserFullNameError = '';
    if (user_full_name.length === 0) this.messageUserFullNameError = '';
  }

  validateUserLastName() {
    const last_name: string = this.profileForm.get('lastName')?.value.trim();
    console.log('lastName', last_name);
    if (
      (last_name.length < 3 || last_name.length > 50) &&
      last_name.length != 0
    )
      this.messageUserFullLastNameError =
        'Apellido debe tener de 3 a 30 caracteres';
    else if (!RegExp(ToolsValidations.patternUserFullName).test(last_name))
      this.messageUserFullLastNameError =
        'Apellido no puede tener caracteres especiales';
    else this.messageUserFullLastNameError = '';
    if (last_name.length === 0) this.messageUserFullLastNameError = '';
  }

  validatePhoneNumber() {
    const phoneNumber: string = this.profileForm.get('phoneNumber')?.value;
    if (
      (phoneNumber.toString().length < 6 ||
        phoneNumber.toString().length > 12) &&
      phoneNumber.length != 0
    )
      this.messagePhoneNumberError = 'Teléfono debe tener de 8 a 12 números';
    else if (!RegExp(ToolsValidations.patternNumberCustom).test(phoneNumber))
      this.messagePhoneNumberError = 'Teléfono debe tener de 8 a 12 números';
    else this.messagePhoneNumberError = '';
    if (phoneNumber.length === 0) this.messagePhoneNumberError = '';
  }

  saveData() {
    this.loading = true;
    this.apiService
      .updateDirect(ApiCore.USER, {
        firstName: this.profileForm.get('firstName')?.value,
        lastName: this.profileForm.get('lastName')?.value,
        birthday: this.profileForm.get('birthday')?.value,
        phoneNumber: this.profileForm.get('phoneNumber')?.value,
        genderCatId: this.profileForm.get('genere')?.value,
      })
      .subscribe({
        next: (res) => {
          this.userProfile = res.data;
          this.messageService.add({
            key: 'tc',
            severity: 'success',
            summary: 'Información personal actualizada satisfactoriamente',
          });
          this.setValues();
          this.loading = false;
          this.formIsDifferent = false;
          this.profileForm.markAsPristine();
          this.eventMenuProfileService.emitSavingUser();
        },
        error: () => {
          this.profileForm.markAsPristine();
          this.messageService.add({
            key: 'tc',
            severity: 'error',
            summary: 'Error al actualizar la información personal',
          });
        },
      });
  }
  customValidator(name: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (value.length < 3 || value.length > 50) {
        return { custom: `${name} debe tener de 3 a 30 caracteres` };
      }
      const regex = new RegExp(ToolsValidations.patternContactName, 'gi');
      if (!regex.test(value)) {
        return { custom: `${name} no puede tener caracteres especiales` };
      }
      return null;
    };
  }
  validatorPhone(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const regex = new RegExp(ToolsValidations.patternNumber8digits);
      if (!regex.test(value)) {
        return { custom: `Teléfono debe tener de 8 a 12 números` };
      }
      return null;
    };
  }
  changePicture(fileInput: any) {
    this.loadingPicture = true;
    this.showLoadSkeleton = true;
    if (fileInput.target.files.length > 0) {
      let fileReaded = fileInput.target.files[0];
      if (fileReaded?.size > 2000000) {
        this.messageService.add({
          key: 'tc',
          severity: 'error',
          summary: 'La imagen no puede pesar más de 2MB',
        });
        this.showLoadSkeleton = false;
        this.loadingPicture = false;
        return;
      }
      this.apiService
        .uploadImageProfile(ApiCore.USER_UPLOAD_IMAGE_PROFILE, fileReaded)
        .subscribe({
          next: (response: any) => {
            const urlPicture =
              response.data?.profilePictureUrl ??
              AppConstants.IMAGE_AVATAR_DEFAULT;
            this.messageService.add({
              key: 'tc',
              severity: 'success',
              summary: 'Imagen actualizada satisfactoriamente',
            });
            this.eventMenuProfileService.emitNewPictureEvent(urlPicture);
            this.loadingPicture = false;
            this.profilePicture = urlPicture;
            this.profileInMobile = urlPicture;
            // this.loadUserData();
            // this.menuemitLoadingNewPicture();
          },
          error: (error: any) => {
            this.loadingPicture = false;
            console.error(error);
            this.messageService.add({
              key: 'tc',
              severity: 'error',
              summary: 'Tu imagen de perfil no se ha podido actualizar',
            });
            this.showLoadSkeleton = false;
          },
          complete: () => {
            this.loadingPicture = false;
            this.showLoadSkeleton = false;
          },
        });
    } else {
      this.loadingPicture = false;
      this.showLoadSkeleton = false;
    }
  }
  toggleCalendar() {
    this.calendarOpen = !this.calendarOpen;
  }
  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  minAgeValidator(minAge: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      console.log({ value: control.value });
      const birthday = moment(control.value, 'YYYY-MM-DD', true); // 👈 importante
      console.log({ birthday });
      if (!birthday.isValid()) {
        return { invalidDate: true };
      }

      const today = moment();
      const age = today.diff(birthday, 'years');
      console.log({ age, minAge, today });
      return age >= minAge
        ? null
        : { minAge: { requiredAge: minAge, actualAge: age } };
    };
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Tab') {
      event.preventDefault();
    }
  }
  sanitizeNumber(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ''); // removes all non-digits
    this.profileForm.get('phoneNumber')?.setValue(input.value, { emitEvent: false });
  }
}
